<template>
<div class="login">
    <v-container>
        <v-row align="center" justify="center">
            <v-col cols="4">
                <v-card>
                    <v-card-title class="d-flex justify-center">
                        <h3 class="text-center">Login</h3>
                    </v-card-title>
                    <v-card-text>
                        <v-form>
                            <v-col>
                                <v-text-field v-model="username" label="Login" dense outlined hide-details="auto" @keyup.enter="checkuserAuthenticate()"></v-text-field>
                            </v-col>
                            <v-col>
                                <v-text-field v-model="userpswd" label="Password"  type="password" dense outlined hide-details="auto" @keyup.enter="checkuserAuthenticate()"></v-text-field>
                            </v-col>

                            <v-col>
                                <v-btn :disabled="isButtonDisabled" block depressed color="primary" @keyup.enter="checkuserAuthenticate()" @click="checkuserAuthenticate()">
                                    <v-icon right dark> mdi-account-key-outline </v-icon>
                                    <span class="button-caption">Login</span>
                                </v-btn>
                            </v-col>
                            <v-alert v-if="ishaveerror" type="error">
                                {{ this.apistatusmsg }}
                            </v-alert>
                            
                        </v-form>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</div>
</template>

<script>
import axios from "axios";
import Vue from "vue";
import VueAxios from "vue-axios";
import apifactory from '../apis/apifactory';
import globalvar from '../global/globalvar';

Vue.use(VueAxios, axios);
export default {
    name: "Login",
    data: () => ({
        userinfo: null,
      
        username: null,
        userpswd: null,

        userid: null,
        strkey: null,
        appid: globalvar.appid,
        loginusername: null,
        apistatuscode: null,
        apistatusmsg: null,
        ishaveerror: false,
        isButtonDisabled: false
    }),
    methods: {
       
        checkuserAuthenticate() {

      
            this.checkuserlogin();
            if (this.userid != null) {
      
                let newurl = "/ExtraAuth/?user_id=" + this.userid + "&key=" + this.strkey + "&app_id=" + this.appid;
                this.goTo(newurl);

      
            }
      

        },

        checkuserlogin() {
          
            apifactory.userAthenticate(this.username, this.userpswd)
                .then((res) => {
      
      
                    if (res.status != 200) {
                        this.apistatusmsg = res.data.message;
                        this.ishaveerror = false;

                    } else {
                        this.userinfo = res.data;
                        alert(JSON.stringify( res.data));
                        if (res.data.status == 1) {
                            this.ishaveerror = false;
                            this.apistatuscode = res.data.status;
                            this.apistatusmsg = res.data.message;
                            this.loginusername = res.data.username;
                            this.strkey = res.data.key;
                            this.userid = res.data.id;
                            localStorage.setItem('SET_USERNAME', this.loginusername)
                            localStorage.setItem('SET_USERID', this.userid)

                        } else {
                            this.apistatusmsg = res.data.message;
                            this.ishaveerror = true;

                        }

                    }
                })
                .catch(function (error) {
                     alert(JSON.stringify(error));
                    //console.warn(error);
                });
        },
        goTo(url) {
            return this.$router.push(url);
        }
    },
    mounted() {
        window.localStorage.clear();
      
    },
    watch: {
        username: function () {
            if (this.username.length > 0) {
                this.isButtonDisabled = false;
            } else {
                this.isButtonDisabled = true;
            }
      
        }
    }

};
</script>
